import { createAction } from "redux-actions";

const SET_TITLE = "HEADER/SET_TITLE";

export const setHeaderTitle = createAction(SET_TITLE);
